import { Stack, styled } from '@mui/material';

// ------------------------------------------------------------

export const StyledContainer = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  backgroundSize: 'cover',
  backgroundImage: 'url(/images/capa/capa4.webp)',
  backgroundPosition: 'center',
}));

export const StyledLogo = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '100vh',
  overflow: 'hidden',
}));

export const StyledLogoContent = styled(Stack)(() => ({
  width: ' 100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledPicture = styled(Stack)(() => ({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
}));
